module.exports = __webpack_public_path__ + "static/media/gastro-icon-section.76a49e6b.png";